export interface RecentlyViewedStockItem {
  symbol: string;
  fullName: string;
  ltp: number;
  changePrice: string;
  perChange: string;
  redirectURL: string;
  stockStatus: "positive" | "negative" | "neutral";
  exchange?: number;
  token?: number;
}

export const RECENTLY_VIEWED_SKELETON_COUNT = 6;

export const RECENTLY_VIEWED_DEFAULT_SECTION_TITLE = "Recently viewed";

export const RECENTLY_VIEWED_CONTENT_DEFAULTS = {
  errorMessage: "No stocks found.",
  modalTitle: "Add to Watchlist",
  modalBtnCta: "Add",
  successMsg: "Added to watchlist successfully",
  errorMsg: "Failed to add to watchlist",
} as const;
